



















































import Vue from 'vue';
import Spinner from '../components/common/Spinner/Spinner.vue';
import GNB from '../components/common/GNB/GNB.vue';
import Folder from '../components/ExplorerView/Folder.vue';
import LabelsetView from './LabelsetView.vue';
import ExplorerHeader from '../components/ExplorerView/ExplorerHeader.vue';
import WorkspaceCreateView from './WorkspaceCreateView.vue';
import DatasetCreateView from './DatasetCreateView.vue';
import AgentDownloadModal from '../components/common/Modal/AgentDownloadModal.vue';

import { axiosApiInstance } from '../utils/axiosInstances';
import { getWorkspaceList, getDatasetList } from '../utils/getFolderList';
import { folderI } from '../interfaces/folderI';
import { showUnsupportedMessage } from '@/utils/demoUtils';

export default Vue.extend({
  components: {
    GNB,
    Spinner,
    Folder,
    LabelsetView,
    ExplorerHeader,
    WorkspaceCreateView,
    DatasetCreateView,
    AgentDownloadModal,
  },
  data(): {
    folderList: folderI[];
    datasetId: string;
    datasetName: string;
    explorerHeaderName: string;
    isWorkspaceCreateViewVisible: boolean;
    isDatasetCreateViewVisible: boolean;
  } {
    return {
      folderList: [],
      datasetId: '',
      datasetName: '',
      explorerHeaderName: 'Workspaces',
      isWorkspaceCreateViewVisible: false,
      isDatasetCreateViewVisible: false,
    };
  },
  watch: {
    $route() {
      this.updateExplorerHeaderName();
      this.getFolderList();

      if (this.$route.params.datasetId !== undefined) {
        this.datasetId = this.$route.params.datasetId;
        axiosApiInstance
          .get(`/api/v1/datasets/${this.$route.params.datasetId}`)
          .then((response) => {
            this.datasetName = response.data.result.name;
          });
      }
    },
  },
  created() {
    this.updateExplorerHeaderName();
    this.getFolderList();

    this.$store.commit('clearAnalysis');

    if (this.$route.params.datasetId !== undefined) {
      this.datasetId = this.$route.params.datasetId;
      axiosApiInstance
        .get(`/api/v1/datasets/${this.$route.params.datasetId}`)
        .then((response) => {
          this.datasetName = response.data.result.name;
        })
        .catch((e) => {
          console.error(e);
          this.$router.push('/demo');
        });
    }
  },
  methods: {
    updateFolderList(newFolder: folderI) {
      let newFolderList = this.folderList;
      newFolderList.push(newFolder);
      this.folderList = newFolderList;
    },
    onClickCreateButton() {
      showUnsupportedMessage(this.$toast);

      // console.log('clickCreateButton');
      // if (this.isDataset()) {
      //   this.isDatasetCreateViewVisible = true;
      // } else {
      //   this.isWorkspaceCreateViewVisible = true;
      // }
    },
    updateExplorerHeaderName() {
      if (this.isDataset()) {
        this.explorerHeaderName = 'Datasets';
      } else {
        this.explorerHeaderName = 'Workspaces';
      }
    },
    isDataset(): boolean {
      if (this.$route.path.split('/').includes('workspace')) {
        return true;
      }
      return false;
    },
    getFolderList() {
      if (this.$route.params.datasetId !== undefined) {
        //datasetId를 전달, labelSet component mount 시작
        this.datasetId = this.$route.params.datasetId;
      } else {
        this.datasetId = '';
        this.datasetName = '';
        this.$store.commit('startLoading');

        if (this.$route.params.workspaceId === undefined) {
          //home page에서 받아올 data 불러오기
          getWorkspaceList()
            .then((workspaceList) => {
              this.folderList = workspaceList;
              this.$store.commit('stopLoading');
            })
            .catch((e) => {
              console.error(e);
              this.$router.push('/demo');
            });
        } else {
          //workspace 내의 dataset을 불러오기
          getDatasetList(this.$route.params.workspaceId)
            .then((datasetList) => {
              this.folderList = datasetList;
              this.$store.commit('stopLoading');
            })
            .catch((e) => {
              console.error(e);
              this.$router.push('/demo');
            });
        }
      }
    },
    onClickFolder(spaceInfo: { folderId: string; folderName: string }) {
      if (this.$route.params.workspaceId === undefined) {
        this.$router.push(`/workspace/` + spaceInfo.folderId);
      } else if (this.$route.params.datasetId === undefined) {
        this.$router.push(this.$route.path + '/dataset/' + spaceInfo.folderId);
        this.datasetId = spaceInfo.folderId;
        this.datasetName = spaceInfo.folderName;
      }
    },
    onClickDelete(spaceInfo: { folderId: string; folderName: string }) {
      this.$store.commit('startLoading');
      if (this.isDataset()) {
        axiosApiInstance
          .delete(`/api/v1/datasets/${spaceInfo.folderId}`)
          .then((response) => {
            this.datasetId = '';

            const newDatasetList = this.folderList.filter((folder: any) => {
              if (folder.id === spaceInfo.folderId) {
                return false;
              }
              return true;
            });

            this.folderList = newDatasetList;
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
      } else {
        axiosApiInstance
          .delete(`/api/v1/workspaces/${spaceInfo.folderId}`)
          .then((response) => {
            const newDatasetList = this.folderList.filter((folder: any) => {
              if (folder.id === spaceInfo.folderId) {
                return false;
              }
              return true;
            });

            this.folderList = newDatasetList;
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
      }
    },
    onCloseLabelset() {
      const parsedURL = this.$route.path.split('/');
      parsedURL.pop();
      parsedURL.pop();
      this.$router.push(parsedURL.join('/'));

      this.datasetId = '';
      this.datasetName = '';
    },
  },
});
